import React from "react";
import { Box, Grid, Card, CardActionArea, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as Icons from "@mui/icons-material"; // use any MUI icons


const quickLinks = [
  { title: "Dashboard", icon: Icons.Dashboard, path: "/dashboard",redirect:'home', color: "#4f46e5" },
  { title: "Staff", icon: Icons.Group, path: "/staff/profile/", redirect:'list-staff', color: "#2563eb" },
  { title: "Campaigns", icon: Icons.Campaign, path: "/staff/campaigns/", redirect:'list-campaigns',color: "#0d9488" },
  { title: "News", icon: Icons.Upcoming, path: "/staff/articles/", redirect:'list-news',color: "#cd9488" },
  { title: "Donations", icon: Icons.VolunteerActivism, path: "/donations",redirect:'home', color: "#059669" },
  { title: "Reports", icon: Icons.Analytics, path: "/reports", redirect:'home', color: "#ea580c" },
  { title: "Settings", icon: Icons.Settings, path: "/settings",redirect:'home', color: "#dc2626" },
  { title: "Documents", icon: Icons.Folder, path: "/staff/resources/",redirect:'list-resources', color: "#7c3aed" },
  { title: "Users", icon: Icons.Person, path: "/staff/profile/",redirect:'list-staff', color: "#9333ea" },
  { title: "Control Panel", icon: Icons.AdminPanelSettings, url: "https://file.fountainafrica.org/cp", newTab: true,color: "#502f96" },
  { title: "Staff Email", icon: Icons.AttachEmail, url: "https://mbox.fountainafrica.org/", newTab: true,color: "#4794e6" },
];

const QuickLinks = () => {
  const navigate = useNavigate();

  const handleClick = (item) => {
    // Internal navigation (React Router)
    // event
    if (item.path) {
      navigate(item.path,{state:{redirect: `${item?.redirect}`}});
      return;
    }

    // External links or files
    if (item.url) {
      if (item.newTab) {
        window.open(item.url, "_blank", "noopener noreferrer");
      } else {
        window.location.href = item.url; // same tab
      }
      return;
    }

    console.warn("No path or url defined for Quick Link:", item);
  };

  return (
    <Box sx={{ mt: 5 }}>
      <Typography
        variant="h5"
        fontWeight="700"
        sx={{ mb: 3, color: "#1f2937", textAlign: "center" }}
      >
        Quick Links
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        {quickLinks.map((item, index) => {
          const Icon = item.icon;

          return (
            <Grid item xs={6} sm={4} md={3} key={index}>
              <Card
                sx={{
                  borderRadius: 3,
                  height: 140,
                  bgcolor: item.color,
                  color: "#fff",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                  transition: "0.3s",
                  ":hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
                  },
                }}
              >
                <CardActionArea
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 2,
                  }}
                  onClick={() => handleClick(item)}
                >
                  <Icon sx={{ fontSize: 40, mb: 1 }} />
                  <Typography variant="subtitle1" fontWeight="600">
                    {item.title}
                  </Typography>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default QuickLinks;
